import { Controller } from "stimulus";
import { EventGeckoChartRendered } from "../../events";

export default class extends Controller {
  static targets = ["holdings", "holdingsChart"];

  handleHoldings(e) {
    const toggleTarget = e.currentTarget.querySelector("input");

    toggleTarget.checked = !toggleTarget.checked;
    this.holdingsTarget.classList.toggle("tw-hidden");

    if (!this.rendered) {
      this.holdingsChartTarget.dataset.pieChartRerenderValue = true;
      this.rendered = true;
    }
  }
}
